import React, { JSX } from "react";
import { Tooltip, Box } from "@mui/material";
import { useTheme } from "@mui/material";
import SimpleSparkline from "components/charting/SimpleSparkline";
import { MakeDrilldownQueryFromHistogramIndex } from "components/widgets/utility/DrilldownQuery";
import SubqueriesSparklineTooltip from "../Tooltips/SubqueriesSparklineTooltip";
import { Query } from "system/query/Query";

export interface SubqueriesSparklineProps {
  rowResponse: any;
  rootResponse: any;
  setValueDrilldownQuery: (query?: Query) => void;
  setValueDrilldownTitle: (title: string) => void;
}

export default function SubqueriesSparkline(props: SubqueriesSparklineProps): JSX.Element {
  const theme = useTheme();

  const { rowResponse, rootResponse, setValueDrilldownQuery, setValueDrilldownTitle } = props;

  const [hoveredSparklineIndex, setHoveredSparklineIndex] = React.useState<number | null>(null); 

  const rowBody = rowResponse.responseBody;

  const socialUniverseHistogram = rowBody?.histogram?._buckets || [];
  const socialUniverseDatapoints = socialUniverseHistogram?.map((bucket: any) => bucket.social_universe || 0) || [];

  // We want a regular API response, but the drilldown code expects a flattened one
  const drilldownHistogram = rowBody?.histogram?._buckets?.reduce((memo: any, row: any) => {
    memo.keys.push(row._key);
    memo.labels.push(row._label);
    return memo;
  }, {keys: [], labels: []});

  return (
    <Tooltip title={<SubqueriesSparklineTooltip rowResponse={rowResponse} rootResponse={rootResponse} hoveredSparklineIndex={hoveredSparklineIndex} />}
      open={hoveredSparklineIndex !== null}
      followCursor={true}>
      <Box sx={{
          width: "100%", height: "50px",
          textAlign: "right",
          position: "relative",
          marginTop: "-3px",
          marginBottom: "-5px",
          padding: 0 }}>
        <SimpleSparkline
          numericData={socialUniverseDatapoints}
          areaFillColor={theme.palette.primary.main}
          setHoveredIndex={idx => {
            setHoveredSparklineIndex(idx ?? null)
          }}
          onClick={(index) => {
            const drilldownInfo = MakeDrilldownQueryFromHistogramIndex(drilldownHistogram, rowBody?.histogram?._field_id, index);
            if (!drilldownInfo) return;
            setValueDrilldownTitle(`${rowBody?.histogram?._field_label}: ${drilldownInfo?.title}`);
            setValueDrilldownQuery(drilldownInfo?.query);
          }} />
      </Box>
    </Tooltip>
  );
}